import { useQuery } from "@tanstack/react-query";
import { attemptOrgUsers } from "../../api/OrgApi";

const fetchOrgUsers = async (organisationId) => {
    return attemptOrgUsers(organisationId).then((res) => res.data);
};

export const useGetOrgUsers = (organisationId) => {
    return useQuery({ 
        queryKey: ['org-users', organisationId], 
        queryFn: () => fetchOrgUsers(organisationId),
        enabled: !!organisationId, // Only run query if organisation ID is available
        staleTime: 0, // Data is considered stale immediately
        cacheTime: 0, // Cache is cleared immediately after unmount
        refetchOnWindowFocus: false,
        refetchOnMount: true,
        refetchOnReconnect: true,
    });
};
